<app-layout-auth [isHeroHiddenOnMobile]="true">
  <div class="pt-(--ion-safe-area-top)"></div>
  @switch (step) {
    @case (Step.EMAIL) {
      <step-email
        (toPrev)="onBack()"
        (toNext)="onToStepOtp($event)" />
    }
    @case (Step.OTP) {
      <step-otp
        [email]="email()"
        (toPrev)="onBack()"
        (toNext)="onToStepPassword($event)" />
    }
    @case (Step.PASSWORD) {
      <step-pin
        [token]="token()"
        [email]="email()"
        (toPrev)="onBack()"
        (toNext)="onToStepCompletion()" />
    }
    @case (Step.COMPLETION) {
      <step-completion (completed)="back.emit()" />
    }
  }
  <div class="mx-auto max-w-sm px-6 md:-mt-32">
    <p class="text-center text-text-default text-sm">
      Sudah ingat?
      <button
        class="text-text-brand underline"
        (click)="onBack()">
        Kembali
      </button>
    </p>
  </div>
</app-layout-auth>
